var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuotation = function SvgQuotation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quotation_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875 5.937v2.188c0 1.202-.842 2.246-2.001 2.481A.938.938 0 0 1 4.5 8.768c.28-.056.498-.34.498-.643h-.312a.938.938 0 0 1-.938-.938V6.25C3.75 5.56 4.31 5 5 5h.938c.517 0 .937.42.937.937ZM10.312 5h-.937c-.69 0-1.25.56-1.25 1.25v.937c0 .518.42.938.937.938h.313c0 .304-.22.587-.499.644a.937.937 0 1 0 .373 1.837c1.159-.235 2-1.279 2-2.481V5.937A.938.938 0 0 0 10.313 5ZM15 7.702v3.973A3.327 3.327 0 0 1 11.676 15h-3.53C3.789 15 .295 12.005.019 8.033A7.517 7.517 0 0 1 2.192 2.2 7.494 7.494 0 0 1 8.022.018C11.935.283 15 3.658 15 7.702Zm-1.875 0c0-3.06-2.298-5.615-5.23-5.814A5.632 5.632 0 0 0 3.52 3.525a5.64 5.64 0 0 0-1.63 4.378c.209 3.026 2.84 5.221 6.257 5.221h3.53a1.45 1.45 0 0 0 1.448-1.449V7.702Z",
    fill: "#30384C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "quotation_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15v15H0z"
  })))));
};
export default SvgQuotation;